// Custom components
import { FormControl, FormLabel, InputGroup } from "@chakra-ui/react";
import React from "react";

function TextField(props) {
  const { label, id, required = false, extra, placeholder, variant, state, disabled, value, name, onChange, autoFocus = false, extrainput = '', maxLength = 150 } = props;

  return (
    <div className={`${extra}`}>
      <FormControl isRequired={required}>
        <FormLabel className="!text-sm !text-navy-700 dark:!text-white !font-bold" htmlFor={id}>{label}</FormLabel>
        <InputGroup>
          <textarea
            required={required}
            autoFocus={autoFocus}
            placeholder={placeholder}
            maxLength={maxLength}
            name={name}
            value={value}
            onChange={onChange}
            id={id}
            className={`flex h-12 w-full min-h-[100px] max-h-[100px] items-center justify-center rounded-xl !border-[2.5px] p-3 text-sm outline-none transition-all duration-200 ease-in-out
      ${disabled
                ? `!bg-gray-100 dark:!bg-navy-700
           !text-gray-400 dark:!text-gray-400
           !border-gray-300 dark:!border-navy-700
           cursor-not-allowed
           focus:!ring-0 focus:!border-gray-300
           hover:!border-gray-300 dark:hover:!border-navy-700
           shadow-none placeholder:text-gray-300 dark:placeholder:text-gray-600`
                : state === "error"
                  ? `ring-0 border-red-500 text-red-500 placeholder:text-red-500
           dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400`
                  : state === "success"
                    ? `ring-0 border-green-500 text-green-500 placeholder:text-green-500
           dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400`
                    : `!bg-lightPrimary dark:!bg-navy-900
                    !text-gray-800 dark:!text-white
                    !border-gray-300 dark:!border-white/10
           focus:!ring-[1px] focus:!ring-brand-500 focus:!border-brand-500
           dark:focus:!ring-brand-400 dark:focus:!border-brand-400
           hover:!border-brand-500 dark:hover:!border-brand-400
           placeholder:!text-gray-400 dark:placeholder:!text-gray-500`
              }
      ${extrainput}`}
          />
        </InputGroup>
      </FormControl>
    </div>
  );
}

export default TextField;
